/** Nome exibido do módulo (rota `/diretoria`). */
export const DIRETORIA_MODULE_TITLE = 'Tela 10';

/**
 * Exibe KPIs/gráficos de multas (infrações) na Tela 10.
 * Mantido desligado até validação dos dados PortalFly.
 */
export const DIRETORIA_SHOW_MULTAS = false;

/** Destino do link “Clique aqui” no card de apoio Rique.Ia (Tela 10). */
export const DIRETORIA_RIQUE_IA_URL = 'https://rique.ia';
